import { render, staticRenderFns } from "./ModalJobReview.vue?vue&type=template&id=5c9cbdf1&scoped=true&"
import script from "./ModalJobReview.vue?vue&type=script&lang=js&"
export * from "./ModalJobReview.vue?vue&type=script&lang=js&"
import style0 from "./ModalJobReview.vue?vue&type=style&index=0&id=5c9cbdf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9cbdf1",
  null
  
)

export default component.exports